import { PAUSEQUEUE_TASK, PAUSEQUEUE_TASK_SUCCESSFUL, PAUSEQUEUE_TASK_FAILED } from './actionTypes';

export const pauseQueueTask = (task,token,history) => {
    return {
        type: PAUSEQUEUE_TASK,
        payload: { task,token, history }
    }
}

export const pauseQueueTaskSuccessful = (msg) => {
    return {
        type: PAUSEQUEUE_TASK_SUCCESSFUL,
        payload: msg
    }
}

export const pauseQueueTaskFailed = (msg) => {
    return {
        type: PAUSEQUEUE_TASK_FAILED,
        payload: msg
    }
}
